import routes from '@/modules/requests/requests-routes';
import store from '@/modules/requests/requests-store';
export default {
    component: [],
    routes,
    store,
}